<template>
  <div>
    <back />
    <div class="det">
      <div class="top">
        <div class="title">订单信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="项目应用:">
                <div> {{ ruleForm.orderCode }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="付款方式:">
                <div>在线支付</div>
                <!-- <div>线下支付</div> -->
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单编号:">
                <div> {{ ruleForm.orderCode }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单状态:">
                <div v-if="ruleForm.orderStatus == 0" style="color: red;">待支付</div>
                <div v-if="ruleForm.orderStatus == 1">已支付</div>
                <div v-if="ruleForm.orderStatus == 2">已取消</div>
                <div v-if="ruleForm.orderStatus == 3">已退款</div>
              </el-form-item>
              <!-- <el-form-item label="优惠金额:">
                <div>{{ ruleForm.discountAmount }} 元</div>
              </el-form-item> -->
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="订单金额:">
                <div>{{ ruleForm.orderAmount }} 元</div>
              </el-form-item>
              <!-- <el-form-item label="支付金额:">
                <div>{{ ruleForm.payAmount }} 元</div>
              </el-form-item> -->
            </el-col>
            <el-col :span="5">
              <el-form-item label="下单时间:">
                <div>{{ ruleForm.orderTime }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="付款时间:" v-if="ruleForm.paymentTime">
                <div>{{ ruleForm.paymentTime || '--' }}</div>
              </el-form-item>
              <el-form-item label="取消时间:" v-if="!ruleForm.paymentTime">
                <div>{{ ruleForm.cancelTime }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="取消时间:" v-if="ruleForm.paymentTime">
                <div>{{ ruleForm.cancelTime }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 用户信息 -->
      <div class="top">
        <div class="title">用户信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="用户名称：">
                <div>{{ ruleForm.mallUser?.nickName || '--' }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="联系电话：">
                <div>{{ ruleForm.mallUser?.phoneNum || '--' }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="性别：">
                <div>男</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="年龄：">
                <div>20 岁</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 活动信息 -->
      <div class="top">
        <div class="title">活动信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="活动名称：">
                <div>***活动</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="活动分类：">
                <div>室外</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="活动价格：">
                <div>250 元</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="报名截止时间：" label-width="110px">
                <div>2024-09-21 14:13:40</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="活动开始时间：" label-width="110px">
                <div>2024-09-21 14:13:40</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="活动结束时间：" label-width="110px">
                <div>2024-09-21 14:13:40</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
            </el-col>
            <el-col :span="5">
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {},//订单信息
      // tableData: []//服务内容
    };
  },
  created() {
    // this.getRequest()
  },
  methods: {
    // 修改请求当前信息
    getRequest() {
      this.loading = true;
      this.$axios.get(this.$api.projectOrderInfo, {
        params: {
          projectOrderId: this.$route.query.projectOrderId,//订单id
        }
      }).then((res) => {
        const { code, result } = res
        if (code == 100) {
          this.ruleForm = result//订单信息
          this.tableData = result.projectInfoVoList || []//服务内容


        }
      }).catch((err) => {
        this.$message.error(err.desc)
        this.loading = false;
      })

    },

  }
}
</script>

<style scoped lang='scss'>
.det {
  padding: 10px 0 0 10px;

  .title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #1A1A1A;
    text-align: left;
    margin-bottom: 20px;
  }

  .top {
    border-bottom: 1px solid #E2E2E2;
    margin-bottom: 30px;
    padding-bottom: 20px;

    .el-form-item {
      margin-bottom: 0px;
    }
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
}
</style>